"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var adobeWriter_1 = __importDefault(require("./adobeWriter"));
var apiWriter_1 = __importDefault(require("./apiWriter"));
var consoleWriter_1 = __importDefault(require("./consoleWriter"));
function getWriters(options) {
    return __spreadArrays([
        apiWriter_1.default,
        adobeWriter_1.default
    ], (options.isProduction ? [] : [consoleWriter_1.default]));
}
exports.default = getWriters;
//# sourceMappingURL=index.js.map